import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import { DemoDashed, DemoDotted, DemoSolid, DemoNumbered } from './DividerDemo'
import DividerElement from './DividerElement'
import DividerFormBrand from './DividerFormBrand'
import { STYLE_FORM_SCHEMA } from './DividerFormStyle'
import DividerFormValue from './DividerFormValue'
import dividerIcon from './assets/divider.svg'

export default genElementConfig(CONFIG_ELEMENTS.divider, {
  label: t('elements.divider.label'),
  icon: dividerIcon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: DividerElement,
  Demo: [DemoSolid, DemoDashed, DemoDotted, DemoNumbered],
  FormValue: DividerFormValue,
  FormBrand: DividerFormBrand,
  EditorActions: null,
})
